import { render, staticRenderFns } from "./MultiUpdateItem.vue?vue&type=template&id=4d0488ce&scoped=true&"
import script from "./MultiUpdateItem.vue?vue&type=script&lang=js&"
export * from "./MultiUpdateItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0488ce",
  null
  
)

export default component.exports